<script setup lang="ts">
  useZohoDeskAsap();
  const errorModal = useErrorModal();
</script>
<template>
  <main class="">
    <NuxtPage />
    <SystemLayoutsMainMenu />
  </main>
  <CommonErrorModal
    v-model:is-open="errorModal.isOpen.value"
    :title="errorModal.title.value"
    :message="errorModal.message.value"
    @dismiss="errorModal.dismiss()"
  />
</template>
<style scoped></style>
